import { SvgStar } from '../Images/svgs'

export function ModoTarget ({ titulo, dificultad, children, setProp }) {
  const cantDificult = () => {
    const arr = Array(dificultad).fill(null)
    for (let i = 0; i < dificultad; i++) {
      arr[i] = i
    }
    return arr
  }

  const dificutadTitle = () => {
    switch (dificultad) {
      case 1:
        return 'Muy fácil'
      case 2:
        return 'Fácil'
      case 3:
        return 'Medio'
      case 4:
        return 'Díficil'
      case 5:
        return 'Muy díficil'
      default:
        return ''
    }
  }

  const handleClick = () => {
    setProp(true)
  }

  return (
    <div className='flex flex-col justify-between gap-2 p-2 rounded-2xl bg-[#353535] border-2 border-[#303030] w-72 hover:bg-[#383838] max-sm:w-full max-sm:min-h-32 max-lg:w-full' title={dificutadTitle()}>
      <div>

      <h5 className='text-lg font-semibold'>{titulo}</h5>
      <p className='text-sm text-white/70'>{children}</p>
      </div>
      <div className='flex flex-col gap-1.5'>
        <hr className='h-[1px] w-full'/>
        <div className='flex justify-between max-sm:px-3.5'>
          <div className='flex gap-1 items-center'>
            {
            cantDificult().map((e) => {
              return (
                <SvgStar key={e}/>
              )
            })
            }
          </div>
          <div className='rounded-full border-2 border-orange-700 p-0.5'>
            <button onClick={handleClick} className='bg-orange-600 text-white font-semibold p-0.5 rounded-full px-3.5 hover:bg-orange-500'>Jugar</button>
          </div>
        </div>
      </div>
    </div>
  )
}
